import React, { useState, useEffect } from 'react'
import { Alert, AlertTitle } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { useSettings } from '../context/SettingsContext'
import { Nav } from './partials/Nav';
import { API_URL } from './Constants';
import LotInfo from './partials/LotInfo';
import ValCodes from './partials/ValCodes';

const LotDisplay = () => {
  const settings = useSettings();
  const token = settings.userToken;
  const { id } = useParams();

  const [lot, setLot] = useState()
  const [codes, setCodes] = useState()
  const [fee, setFee] = useState()

  /**
   * 
   */
  useEffect(() => {
    document.title = 'Lot Management | ValParx Admin'
    
    if (token && !lot) {
      getData()
    }
  }, []);

  /**
   * 
   */
  const getData = () => {
    setLot(null)

    var myHeaders = new Headers();
    myHeaders.append("vp-session-token", token);

    var formdata = new FormData();
    formdata.append("id", id);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(API_URL + "getlotdata", requestOptions)
      .then(response => response.json())
      .then(result => {
        //console.log(result)
        if (result.code == 200) {
          setLot(result.lot)
          setFee(result.fee)
          setCodes(result.codes)
        } 
      })
      .catch(error => console.log('error', error));
  }

  return (
    <div className='min-h-screen flex items-start justify-center pt-[63px]'>
      <Nav /> 

      {lot ? (
        <div className='w-full'>
          <div className="max-w-4xl mx-auto w-full pt-20">
            <div className='flex justify-between items-center mb-12'>
              <h2 className='mb-0'>{lot.title}</h2>
              <Link to={"/lots/edit/"+id} className="group relative w-full flex justify-center py-2 px-4 border font-bold border-accent border-solid text-md rounded-md text-white hover:text-accent bg-accent hover:bg-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-50 transition items-center max-w-160 m-0">
                Edit Lot
                <FontAwesomeIcon icon="fa-solid fa-circle-plus" className='ml-2' />
              </Link>
            </div>
            
            <LotInfo name={lot.title} fee={fee} />

            <div className='mb-5 flex justify-between items-center'>
              <h3 className='mb-0'>Lot Rate(s)</h3>
              <Link to={"/lots/rates/"+id} className="group relative w-full flex justify-center py-1 px-2 border font-bold border-accent border-solid text-md rounded-md text-white hover:text-accent bg-accent hover:bg-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-50 transition items-center max-w-200 m-0">
                Edit Lot Rates
                <FontAwesomeIcon icon="fa-solid fa-arrow-right" className='ml-2' />
              </Link>
            </div>

            <div className='p-12 pb-8 bg-secondary rounded-xl mb-12'>
              {lot.rates && lot.rates.length > 0 ? (
                <div>
                  <div className='grid grid-cols-3 gap-4 font-bold mb-4'>
                    <div>Time Range</div>
                    <div className='text-center'>Rate</div>
                    <div className='text-right'>Created</div>
                  </div>
                  {lot.rates.map((rate, index) => (
                    <div key={index} className='grid grid-cols-3 gap-4 mb-2'>
                      <div>
                        {rate.start_minutes} to {rate.end_minutes === 0 ? '∞' : rate.end_minutes} minutes
                      </div>
                      <div className='text-center'>${rate.rate_amount}</div>
                      <div className='text-right'>{new Date(rate.created).toLocaleDateString()}</div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className='text-center font-medium'>No rates configured for this lot.</p>
              )}
            </div>

            <div className='mb-12'>
              <h3 className='mb-5'>Available Validation Codes</h3>

              <div className='mb-5'>
                {codes && codes.length > 0 ? (
                  <div className='p-12 pb-8 bg-secondary rounded-xl'>
                    <div className='grid grid-cols-3 gap-4 font-bold mb-4'>
                      <div>Code</div>
                      <div className='text-center'>Created</div>
                      <div className='text-right'>Status</div>
                    </div>
                    {codes.map((code, index) => (
                      <div key={index} className='grid grid-cols-3 gap-4 mb-2'>
                        <div>{code.code}</div>
                        <div className='text-center'>{new Date(code.created).toLocaleDateString()}</div>
                        <div className='text-right'>{code.active === "1" ? "Active" : "Inactive"}</div>
                      </div>
                    ))}
                    {codes.length == 20 && (
                      <p className='mt-8'>Note: Lots can have many codes. We are only showing 20 here. If you need more, please refer to the parking app link below.</p>
                    )}
                  </div>
                ) : (
                  <p className='text-center font-medium'>No foundation codes available for this lot.</p>
                )}
              </div>

              <p>Lot validation codes are created through the American Parking <a className='underline' href="https://americanparking.com/parking/" target='_blank'>parking app.</a></p>
            </div>
          </div>
        </div>
      ) : (
        <div className='text-blueGray-500 items-center flex flex-col text-center justify-center w-full h-screen'>
          <p className='text-4xl font-bold mb-6'>Loading lot data...</p>
          <div><FontAwesomeIcon icon="fa-solid fa-spinner" className='text-5xl ml-2 fa-spin' /></div>
        </div>
      )}
      
    </div>
  )
}

export default LotDisplay
